import axios from 'axios';
import { configRefs } from '@utils/constants';

async function updateRevisionRequest(user, revision) {
  if (!user || !user.institution?.id) {
    throw new Error("updateRevisionRequest(): missing user data");
  }
  if (!revision.__syncedWithBackend) {
    throw new Error("updateRevisionRequest(): revision is not present in the backend");
  }
  await axios.put(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/${encodeURIComponent(revision.id)}`, {
    userID: user.id,
    userInstitutionID: user.institution.id,
    courseID: revision.courseId,
    portalID: revision.portalId,
    title: revision.name,
    content: JSON.stringify(revision.disabledContentIds)
  });
}

export { updateRevisionRequest };
//# sourceMappingURL=request.update.js.map
